<template>
  <div>
    <div class="form_item" :class="save_to + '_wrapper radio-classic'">
      <Label :required="required" :label="label" :for_id="save_to" />
      <div :id="save_to + '_element'">
        <label v-for="(option, index) in compiledOptions" :key="index">
          <input
            type="radio"
            :v-validate="required ? 'required' : undefined"
            :required="required"
            :name="`radio_${save_to}`"
            v-model="val"
            :value="option.value"
          />
          <span data-text="*" v-html="option.name"></span>
        </label>
      </div>
      <p v-if="info !== undefined" class="info" v-html="info"></p>
      <div class="error_container">
        <span
          class="error"
          v-show="
            errors.has(validationLabel || label) &&
            ((fields[validationLabel || label].untouched &&
              !fields[validationLabel || label].dirty) ||
              (fields[validationLabel || label].touched &&
                fields[validationLabel || label].dirty))
          "
          v-text="errors.first(validationLabel || label)"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
function debounce(fn, wait) {
  let timer;
  return function (...args) {
    if (timer) {
      clearTimeout(timer); // clear any pre-existing timer
    }
    const context = this; // get the current context
    timer = setTimeout(() => {
      fn.apply(context, args); // call the function if time expires
    }, wait);
  };
}

import { validatorComponent } from "./validatorComponentMixin";
import Label from "./Label";
import axios from "axios";

export default {
  name: "Input",
  mixins: [validatorComponent],
  data: function () {
    return {
      compiledOptions: [],
    };
  },
  created() {
    const compile = async () => {
      const omitedFields = [
        "rib",
        "bar_code",
        "receipt",
        "id_proof",
        "file_1",
        "file_2",
        "file_3",
        "file_4",
        "file_5",
        "multiple_files",
        "last_name",
        "first_name",
        "email",
        "phone",
        "address",
        "iban",
      ];
      const form = { ...this.form };
      omitedFields.forEach((field) => {
        delete form[field];
      });

      const compiledOptions = [];
      for (const option of this.options) {
        if (
          option.value !== undefined &&
          option.name?.includes("{{amount_to_refund}}")
        ) {
          form[this.save_to] = option.value;
          const { data } = await axios.post(
            (window.promodevServer || "https://api.lucien.ai") +
              "/api/v2/submissions/estimaterefund",
            {
              form: form,
              operationId: this.operationId,
            },
          );

          const amount_to_refund = Math.ceil(data.estimate) / 100;

          compiledOptions.push({
            ...option,
            name: option.name.replace(
              new RegExp(`{{amount_to_refund}}`, "g"),
              `<span class="amount">${amount_to_refund.toLocaleString("fr-FR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}</span>`,
            ),
          });
        } else {
          compiledOptions.push(option);
        }
      }
      this.compiledOptions = compiledOptions;
    };
    this.debouncedEstimate = debounce(compile, 500);
    compile();
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler() {
        if (this.debouncedEstimate) {
          this.debouncedEstimate();
        }
      },
    },
  },
  components: {
    Label,
  },
  props: {
    form: Object,
    label: String,
    validationLabel: String,
    operationId: String,
    options: {
      type: Array,
      required: true,
    },
    save_to: String,
    required: Boolean,
  },
  computed: {
    confirmationName() {
      return this.save_to + "_confirmation";
    },
  },
};
</script>
